import styled from 'styled-components'
import { CourseProgression } from '../../components/Content/CourseProgression'
import { defaultTheme } from '../../styles/themes/defaultTheme'
import { MeetButton } from '../../components/CourseCard/MeetButton'
import { useOrganization } from '../../hooks/useOrganization'
import { useTranslation } from 'react-i18next'
import { useUserCourse } from '../../hooks/queries/useUserCourses'

export const CourseHeader = ({ slugOrId }: { slugOrId?: string }) => {
    const { t } = useTranslation('dashboard')
    const { course, status, courseId } = useUserCourse(slugOrId)
    const { branding } = useOrganization()
    const courseHeaderImage = branding?.courseHeaderImage

    if (status === 'pending') return <CourseHeaderSkeleton />

    return (
        <Header className="content-header-container">
            <Card className="card course-header-image" courseHeaderImage={courseHeaderImage}>
                <div className="left">
                    <h1 className="title no-margins">{course?.courseName}</h1>
                    <CourseProgression courseId={courseId} />
                </div>

                {course?.asyncCourse ? (
                    <div />
                ) : (
                    <div className="display-flex card-buttons">
                        <div>{course?.status === 'finished' ? t('Your course has ended.') : ''}</div>
                        {course && (
                            <>
                                <MeetButton {...course} isInside={true} />
                            </>
                        )}
                    </div>
                )}
            </Card>
        </Header>
    )
}

const CourseHeaderSkeleton = () => {
    return <header className="card skeleton"></header>
}

const Header = styled.header`
    background-color: ${defaultTheme.color.offWhite};

    & > .card {
        align-items: center;
        justify-content: space-between;
    }

    @media screen and (max-width: 1300px) {
        & .card-buttons {
            display: flex;
            flex-direction: column-reverse;
            gap: 0;
        }
    }

    @media screen and (max-width: 470px) {
        & .card {
            display: flex;
            flex-direction: column;
            gap: 1em;
            align-items: center;
            text-align: center;
        }
    }
`

const Card = styled.article<{ courseHeaderImage?: string | null }>`
    display: grid;
    grid-template-columns: auto max-content;
    gap: 1rem;

    &.course-header-image {
        background: ${({ courseHeaderImage }) =>
            courseHeaderImage ? `url(${courseHeaderImage}) center center / cover no-repeat` : `var(--color-light-egg-lead)`};
    }
`
